import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import api from "../../../services/api";
import { IExtractedFilesFilterOptionsResponse } from "../@types";
import { ErrorResponse } from "../../../requests/@types";

const useExtractedFilesFilterOptions = (
  path: string[],
  sampleRelationshipID: number
) => {
  const { data } = useQuery<
    AxiosResponse<IExtractedFilesFilterOptionsResponse>,
    ErrorResponse,
    IExtractedFilesFilterOptionsResponse
  >({
    queryKey: ["extractedFilesFilterOptions", path, sampleRelationshipID],
    queryFn: () =>
      api.getExtractedFilesFilterOptions(path, sampleRelationshipID ?? 0),
    select: ({ data: responseData }) => ({
      file_formats: responseData.file_formats ?? [],
      threat_names: responseData.threat_names ?? []
    })
  });

  return {
    data
  };
};

export default useExtractedFilesFilterOptions;
